export function getNestedObjectValue<T>(obj: T, path: string): any {
  return path.split('.').reduce((acc: any, key: string) => {
    return acc && acc[key]; // Ensure the accumulator is not null/undefined
  }, obj);
}
